<template>
    <div>
        <Header></Header>
        <div class="container">
            <headerPanel field="organization" :data="organizationData" @editOrg="editOrg" :permissions="permissions" :user="user" :users="users" @updateOrganization="getOrganizationF"/>
            <div class="row">
                <div class="col-md-3 px-0 border border-radius-4 mcBgDarkGrey">
                    <organizationDetailPanel :data="this.organization" @editOrg="editOrg" :user="currentUser" field="organizationCard" />
                </div>
                <div class="col-md-9 pl-0 pl-md-3 mt-3 mt-md-0">
                    
                    <div class="row ml-0 border border-radius-4 mcBgDarkGrey">
                        <ul class="row w-100 mx-0 crm-modal-header nav dealCenterUl hpx-50 px-3 mincrm-dynamic-tabs border-radius-4" > 
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a class="active" href="#organizationAll" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('SUMMARY')}}</a> 
                            </li>
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#contactDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('PERSONS')}}</a> 
                            </li>  
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#dealDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('OPPORTUNITIES')}}</a> 
                            </li>   
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#activitiesDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('ACTIVITIES')}}</a> 
                            </li>   
                            <li class="w-auto text-center bg-crm-tab dNoneMobil"> 
                                <a href="#processesDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('PROCESSES')}}</a> 
                            </li> 
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#showNotePanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('NOTES')}}</a> 
                            </li>   
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#showMailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('EMAIL')}}</a> 
                            </li>   
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#specialArea" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('SPECIAL_AREA')}}</a> 
                            </li> 
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#filePanel" @click="watchUpdated=watchUpdated+1" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('FILE')}}</a> 
                            </li>                                                                                             
                        </ul>
                        <div class="col-12 bg-white">
                           
                            <div class="row tab-content" style="min-height:200px">

                                <div class="col-12 tab-pane active" id="organizationAll">
                                    <completeShowPanel field="info" :organization="organizationData" :users="this.users" />
                                </div>

                                <div class="col-12 tab-pane"  id="contactDetailPanel">
                                    <contactList :organization="organization" :type="dataType" :users="users" :user="user" @getData="organizationData.contacts=$event" field="organizationCard" :data="organizationData.contacts"/>
                                </div>

                                <div class="col-12 tab-pane"  id="dealDetailPanel">
                                    <dealDetailPanel :users="users" :user="currentUser" :data="organizationData.deals" :organization="organizationData"/>
                                </div>

                                <div class="col-12 tab-pane"  id="activitiesDetailPanel">
                                    <activitiesDetailPanel ref="ata" field='org' @updateActivity="updateActivity($event)" @datagetActivitiesByOrganization="getActivitiesByOrganizationF($event)" :users="users" @refleshData="getOrganizationF()" :data="organizationActivities"/>
                                     <div ref="intersectionElement" style="height: 100px; "></div>
                                </div>

                                <div class="col-12 tab-pane"  id="processesDetailPanel">
                                    <processesDetailPanel field="organization" :users="users" :dataId="organizationId"/>
                                </div>

                                <div class="col-12 tab-pane"  id="showNotePanel">
                                    <div class="row">
                                        <div class="col-11 col-md-8 m-auto pt-3">
                                            <addNotePanel @updateOrgNote="note.push($event),getOrganizationF()" :data="organizationData" postField="organization" />
                                            <showNotePanel field="organization" :data="note" :organization="organizationData" @refleshData="getOrganizationF()" :users="users"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 tab-pane"  id="showMailPanel">
                                    <div class="row">
                                        <div class="col-10 m-auto">
                                            <showMailPanel :orgId="this.organizationId" :users="this.users" />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 tab-pane"  id="specialArea">
                                    <special-area type="profil" postField="organization" @updateData="getOrganizationF()" :users="users" :user="currentUser" :data="organizationData" :customField="organizationCustomFields" :allcustomFieldArray="organizationCustomFields"></special-area>
                                </div>

                                <div class="col-12 tab-pane pt-3" id="filePanel">
                                      <file :customerFiles="customerFiles"
                                            :watchUpdated="watchUpdated"
                                            @showCustomerFile="showCustomerFile($event)"
                                            :showButton="true"
                                            :organizationData="organizationData"
                                            @addNewFile="addNewFile($event)"
                                            @deleteFile="function($event){ 
                                                for(k in this.customerFiles){
                                                if(this.customerFiles[k]['oid']==$event['oid']){
                                                    this.customerFiles.splice(k,1)
                                                    }
                                                }}"
                                      ></file>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="organizationData.length!=0" class="modal fade in" id="addOrganizationModal" ref="vuemodal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="addOrganizationModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
                    <div class="modal-content mcBgGrey crm-modal-content">
                        <!-- <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">{{$ml.get('COMPANY')}} {{isEditMode?$ml.get("EDIT"):$ml.get("ADD")}}</h5>
                            <button type="button" class="close font-40" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div> -->
                        <div class="modal-body p-0">
                            <newOrganization :data="organizationData" ref="newOrganization" :isEditMode="true" :user="currentUser" :users="users" @updateList="getOrganizationF()" @updateData="getOrganizationF()" :customFieldArray="organizationCustomFields"></newOrganization>
                        </div>
                    </div>
            </div>
            </div>

            <div class="modal fade" id="noteAdd" ref="vuemodal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
                    <div class="modal-content mcBgGrey" >
                    <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                        <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">{{$ml.get('TAKE_NOTE')}}</h5>
                        <button type="button" class="close font-40" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <addNotePanel @updateOrgNote="note.push($event)" :data="organization" postField="organization" />
                    </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="addActivity" ref="newActivity" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
                    <div class="modal-content crm-modal-content">
                        <newActivity :updateActictyId="this.updateActictyId" pageIs="dataType" :clearModal="clearModal" :listenStateStatus="this.listenStateStatus" :methods='type' :user="user" :users="users" @refleshData="getOrganizationF()" @activityDoneF="activityDoneF()" :data="organization"></newActivity>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="addDeal" ref="dealModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:720px!important">
                    <div class="modal-content crm-modal-content">
                        <newDeal :methods='type' @getData="getOrganizationF()" :data="organization" :user="this.currentUser" :users="this.users" :customFieldArray="dealscustomFieldArray"></newDeal>
                    </div>
                </div>
            </div>
            <!-- Relationship Modal -->
            <div class="modal fade" id="relationship" ref="relationship" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content" >
                        <div class="modal-body">
                            <relationship @updateData="relationShipData($event)" ref="modalRelationship" :data="this.organization" />
                        </div>
                    </div>
                </div>
            </div>
            <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
        </div>
    </div>
</template>
  
<script>
    import Vue from 'vue'
    import Header from './header'
    import axios from 'axios'
    import {mapState,mapActions,mapGetters} from 'vuex'
    import _ from 'underscore'
    import specialArea from '@/components/customField'
    import showMailPanel from '@/components/showMailPanel'
    import relationship from './relationship.vue'
    import headerPanel from '@/components/headerPanel'
    import contactDetailPanel from '@/components/contactDetailPanel'
    import organizationDetailPanel from '@/components/organizationDetailPanel'
    import activitiesDetailPanel from '@/components/activitiesDetailPanel'
    import processesDetailPanel from '@/components/processesDetailPanel'
    import completeShowPanel from '@/components/completeShowPanel'
    import dealDetailPanel from '@/components/dealDetailPanel'
    import newActivity from '@/components/newActivity'
    import addNotePanel from '@/components/addNotePanel'
    import showNotePanel from '@/components/showNotePanel'
    import newOrganization from "@/components/newOrganization.vue"
    import newDeal from "@/components/newDeal.vue"
    import contactList from "@/components/contactList.vue"
    import File from './file.vue'
    
    export default {
        name: 'organizationCard',
        components: {
            Header,
            'special-area':specialArea,
            'headerPanel':headerPanel,
            'contactDetailPanel':contactDetailPanel,
            'organizationDetailPanel':organizationDetailPanel,
            'activitiesDetailPanel':activitiesDetailPanel,
            'processesDetailPanel':processesDetailPanel,
            'completeShowPanel':completeShowPanel,
            'addNotePanel':addNotePanel,
            'showNotePanel':showNotePanel,
            'dealDetailPanel':dealDetailPanel,
            'newActivity':newActivity,
            "relationship":relationship,
            "showMailPanel":showMailPanel,
            "newOrganization":newOrganization,
            "contactList":contactList,     
            "newDeal":newDeal,
            File
      },
      data () {
      return {
                updateActictyId:"",
                clearModal:false,
                dealscustomFieldArray:[],
                organizationId:null,
                deal:[],
                activities:[],
                contact:[],
                organizationData:[],
                contactId:"",
                addPhoneText:"",
                addEmailText:"",
                isHiddenContact:true,
                isHiddenContactSelect:false,
                contactPhoneNumber:[],
                organizationPhoneNumber:[],
                items:[],
                currentUser:[],
                stateId:"",
                search:"",
                isHiddenTitle:false,
                isHiddenValue:false,
                isHiddenAddr:false,
                isHiddenPhone:false,
                updateContactPhoneText:"",
                updateContactEmailText:"",
                dealLoseSelect:0,
                dealLoseInput:"",
                selected: undefined,
                type:"save",
                test:[],
                dataType:"organization",
                note:[],
                contactNote:[],
                status:false,
                permissions:[],
                isEditMode:true,
                customerFiles:[],
                watchUpdated:0,
                organizationActivities:[],
                pagingSize:30,
                pagingOffset:0,
                bottom:false,
                observer:"",
                scrollgetActivities:"0"
            }
        },
        computed:{
            listenState() {
                return this.$store.state.editLine;
            },
            listenStateStatus() {
                return this.$store.state.editLineStatu;
            },
            ...mapState([
                'baseUrl',
                'editLineStatu'
            ]),
            ...mapGetters(['organization','user','users','organizationCustomFields','ownerId'])
        },
        beforeMount() {
            if(!this.isOwner&&!this.$can('can_see_other_users_organizations')){
                this.$router.push('/organizations')
            }
        },
        methods:{
            ...mapActions(['getOrganization','updateLoading']),
            isOwner(){
                if(this.organization.cuid){
                    return this.ownerId==this.organization.cuid.$oid
                }
            },
            getActivitiesByOrganizationF(e){
                this.organizationActivities=[]
                this.pagingSize=30;
                this.pagingOffset=0;
                this.getActivitiesByOrganization(e)
            },
            getActivitiesByOrganization(e) {
                this.scrollgetActivities=e
                var params = {};
                if(e=="1"){
                    params.type="1"
                }
                if(e=="2"){
                    params.type="2"
                }
                if(e=="3"){
                    params.type="3"
                }
                if(e=="4"){
                    params.type="4" 
                }
                if(e=="true"){
                    params.done=true
                }
                if(e=="false"){
                    params.done=false
                }
                params.organizationId=this.organizationId
                params.pagingSize=this.pagingSize
                params.pagingOffset=this.pagingOffset
                // params.done="done"
                // params.type="type"
                axios({
                    method: 'POST',
                    url: `/getActivitiesByOrganization`,
                    baseURL: this.baseUrl,
                    data: params,
                    withCredentials: true
                }).then((res) => {
                    return res
                }).then((res) => {
                    if (!res.data.status) {
                        this.$router.push('/logout')
                    }
                    if (res.data.status.code == 0) {
                        // this.$notify({
                        //     group: 'foo',
                        //     type: 'success',
                        //     title: this.$ml.get('ACTIVITY_UPDATE'),
                        //     text: res.data.status.desc
                        // })
                    //   this.organizationActivities=res.data.content.activities
                      if (
                        res.data.content.activities && res.data.content.activities.length == undefined) {
                            const arr = [];
                            arr.push(res.data.content.activities);
                            this.organizationActivities = arr;
                        } else {
                            if (this.isIterable(res.data.content.activities)) {
                                res.data.content.activities.forEach(result => {
                                if (!this.organizationActivities.some(item => item._id.$oid === result._id.$oid)) {
                                    this.organizationActivities.push(result);
                                }
                            });
                            }
                        }
                    } else {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: this.$ml.get('ERROR'),
                            text: res.data.status.desc
                        })
                    }
                })
            },
            isIterable(obj) {
            if (obj == null) {
                return false;
            }
            return typeof obj[Symbol.iterator] === 'function';
            },
            getOrganizationF(){
                this.organizationActivities=[]
                var form = {}
                form.organizationId = this.organizationId
                this.getOrganization(form).then((response) => {
                    if(this.organization.notes!==undefined){
                        this.note=this.organization.notes
                        this.note.reverse()
                    }else{
                        this.note=[]
                    }
                    this.organizationData=this.organization
                    this.permissions=response.permissions
                }).catch(e => {
                    console.log(e)
                })
                this.getActivitiesByOrganization("0")
            },
            activityDoneF(){
                this.pagingSize=30;
                this.pagingOffset=0;
               this.$refs.ata.activityDoneFF()
            },
            editOrg(){
                this.$refs.newOrganization.oldData()
                $('#addOrganizationModal').modal('show') 
            },
            relationShipData(data){
                this.organizationData=data
                this.organization=data
                this.activities=data.crmActivities
    
                if(data.notes!==undefined){
                    this.note=data.notes
                }else{
                    this.note=[]
                }
                if(data.contacts!==undefined &&data.contacts.length>0){
                    data.contacts.forEach((element,index) => {
                        if(element.notes!==undefined){
                            this.contactNote.push(element.notes)
                            if(index>0){
                                this.status=true
                            }
                        }else{
                            this.contactNote=[]
                        }
                    });
                }
            },
            getDealsCustomField(){
                
                axios({
                    method:'POST',
                    url:`/getCustomFields`,
                    baseURL: this.baseUrl,
                    data:{
                        domain:1
                    },
                    withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.data.status.code==0){
                        this.dealscustomFieldArray = res.data.content.customFields
                    }
                    
                })
                
            },
            updateActivity(data){
                data["edit"]=true
                this.$store.dispatch('editLine', data)
                let statu=true
                this.$store.dispatch('editLineStatu', statu)
                this.updateActictyId=data._id.$oid
            },
            activityModalHidden(){
                let statu=false
                this.$store.dispatch('editLineStatu', statu)
                this.clearModal=true
            },
            clearRealtionship(){
                this.$refs.modalRelationship.clear()
            },
            organizationUpdate(obj){
                let id=this.data._id.$oid
                axios({
                 method:'POST',
                 url:'/updateOrganization',
                 baseURL: this.baseUrl,
                    data: {
                    objId:id,
                    updateObj:obj
                 },
                 withCredentials:true
                }).then((res)=>{
                console.log(res);
                 return res
                 }).then((res)=>{
                 if(res.data.status.code==0){
                //  this.organization=res.data.content.organization
                // if(res.data.content.deal.contactId!==undefined){
                //     this.contact=res.data.content.organization.contactId
                //     this.contactId=res.data.content.organization.contactId._id.$oid
                // }
                this.customFields=res.data.content.customFields
                this.isHiddenPhone=false
                this.isHiddenAddr=false
                this.selected=undefined
                this.getOrganizationF()
                this.$notify({ 
                    group: 'foo',
                    type: 'success', 
                    title: this.$ml.get('COMPANY_UPDATED'),
                    text: res.data.status.desc 
                })
                 
                }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc 
                })
                 
                }
             })
            },
            showCustomerFile(event){
                     console.log(event);
                     this.customerFiles=event
            },
            addNewFile(event){
            // this.fileId=event
            console.log(this.fileId);
            this.customerFiles.unshift(event) 
            },
            handleIntersection(entries){
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                    // pagingSize.value += 25;
                    this.pagingOffset += this.pagingSize;
                    this.getActivitiesByOrganization(this.scrollgetActivities);

                    } else {
                    }
                });
            },
        },
        mounted(){
            $(this.$refs.newActivity).on("hidden.bs.modal", this.activityModalHidden);
            $(this.$refs.relationship).on("hidden.bs.modal", this.clearRealtionship);
            $(".mincrm-dynamic-tabs").bootstrapDynamicTabs();
            this.observer = new IntersectionObserver(this.handleIntersection);
            this.observer.observe(this.$refs.intersectionElement);
        },
        created(){
            this.organizationId = this.$route.params.orgId
            this.getOrganizationF()
            this.getDealsCustomField()
            this.$root.$refs.organizationCard=this
        },
        watch: {
            organization(){
                this.organizationData=this.organization
            }
        },
    }
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  .dealLosePopup input{
      border: 1px;
      height: 45px;
  }
  .username {
      font-family: "font-family-regular";
      font-size: 12px;
  }
  .company {
      font-family: "font-family-regular";
      font-size: 10px;
  }
  .updateInput{
      border: 0px;
      border-bottom: 1px solid #66D0FF80;
  }
  .deal-panel {
    border: 1.2px solid #66D0FF;
    border-radius: 50px;
  }
  .deal-title {
    font-family: 'font-family-bold';
    font-size: 18px;
  }
  .dealStatus div:first-child {
    margin-left: 0px;
    z-index: 9;
  }
  .dealStatus div:last-child {
    z-index: 2;
  }
  .dealStatus div {
    margin-left: -30px;
  }
  .dealStatus div button {
    font-family: "font-family-bold";
    border-radius: 20px;
    background-color: white;
    height: 32px;
    border: 1px solid #66D0FF80;
    color: #66D0FF;
    font-weight: normal;
    font-size: 13px;
  }
  .btn-type-1 button{
    font-family: "font-family-bold";
    border-radius: 20px;
    background-color: white;
    height: 27px;
    border: 1px solid #66D0FF80;
    color: #66D0FF;
    font-weight: normal;
    font-size: 10px;
}
.updateInput{
    border: 0px;
    border-bottom: 1px solid #66D0FF80;
}
.deal-panel {
  border: 1.2px solid #66D0FF;
  border-radius: 50px;
}
.deal-title {
  font-family: 'font-family-bold';
  font-size: 18px;
}
.dealStatus div:first-child {
  margin-left: 0px;
  z-index: 9;
}
.dealStatus div:last-child {
  z-index: 2;
}
.dealStatus div {
  margin-left: -30px;
}
.dealStatus div button {
  font-family: "font-family-bold";
  border-radius: 20px;
  background-color: white;
  height: 32px;
  border: 1px solid #66D0FF80;
  color: #66D0FF;
  font-weight: normal;
  font-size: 13px;
}
.btn-type-1 button{
  font-family: "font-family-bold";
  border-radius: 20px;
  background-color: white;
  height: 27px;
  border: 1px solid #66D0FF80;
  color: #66D0FF;
  font-weight: normal;
  font-size: 10px;
}
.dealBtnStyle button {
  font-family: "font-family-bold";
  border-radius: 20px;
  background-color: white;
  height: 36px;
  border: 1px solid #3767a080;
  color: #3767a0;
  font-weight: normal;
  font-size: 14px;
}
.dealBtnStyle button.active {
  background-color: #3767a0!important;
  border: 1px solid #3767a0;
  color: white;
}
.dealStatus label {
  font-family: "font-family-bold";
  font-weight: normal;
  font-size: 10px;
  color: gray;
  padding-left: 25px;
}
.dealStatus .active {
  border-color: #59d816!important;
  color: #59d816!important;
  font-family: "font-family-bold";
  font-weight: normal;
  font-size: 13px;
}
.dealConfig button {
  font-family: "font-family-bold";
  font-weight: normal;
  font-size: 13px;
  border-radius: 20px;
  border: 1px solid #66D0FF80;
  color: #66D0FF;
  background-color: transparent;
}

.dealCenterUl li {
  font-size: 14px;
}
.dealCenterUl li a {
    color: #93959A;
    text-decoration: none;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 13px;
}
.dealCenterUl li a.active {
  color: #1991eb;
  background-color: #E8F4FD;
  font-weight: bold;
  border-bottom: 3px solid #1991EB;
}
.dealCenterNavBar li a.active{
  background-color: #66D0FF30!important;
}
.info-hide {
  font-family: "font-family-bold";
  font-weight: normal;
  font-size: 10px;
  text-transform: uppercase;
}
.dealCartStatus hr {
  border: 1px solid #66D0FF40!important;
  width: 100%!important;
}
.dealCartStatus .active {
  border: 1px solid #66D0FF!important;
}
.iptal:before{
    color:red
}
.add,.edit:hover{
    cursor: pointer;
}
.add:hover:after{
    content: "\e952";
    font-size: 14px;
    margin-left: 0.5em;
    font-family: 'icomoon' !important;
    color: #66D0FF;
}
.edit:hover:after{
    content: "\e913";
    font-size: 14px;
    margin-left: 0.5em;
    font-family: 'icomoon' !important;
    color: #66D0FF;
}
.hide{
    display: none
}
.hide_visible {
    visibility: hidden;
}
.show{
    visibility: visible;
}
.field:hover .icon-line-duzenle{
    visibility: visible;
} 
.mincrm-dynamic-tabs{
    border-bottom: 1px solid #dcdddd;
}
@media (max-width: 768px){
    .dealCenterUl li a.active {
        color: #fff;
        font-weight: bold;
        background-color: #1991eb;
        border-bottom: 3px solid #1991EB;
    }
}
</style>
